<template>
  <div>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
      <!-- ============================================================== -->
      <!-- Container fluid  -->
      <!-- ============================================================== -->
      <div class="container-fluid">
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="row page-titles">
          <div class="col-md-5 align-self-center">
            <h4 class="text-themecolor">Audit Log</h4>
          </div>
          <div class="col-md-7 align-self-center text-right">
            <div class="d-flex justify-content-end align-items-center">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">Audit Log</li>
              </ol>
            </div>
          </div>
        </div>
        <!-- Add Component -->
        <AuditLogComponent ref="auditLogComponent"/>
        <!-- Add Component -->
        <!-- ============================================================== -->
      </div>
      <!-- ============================================================== -->
      <!-- End Container fluid  -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
import axios from "axios";
//import Multiselect from "@vueform/multiselect";
import AuditLogComponent from '../../components/AuditLogComponent.vue'
export default {
  name: "AuditLog",
  components: {
    //Multiselect,
    AuditLogComponent,
  },

  data() {
    return {
      //loader
    
    };
  }, //data

  methods: {
  
  }, // methods

  mounted() {
    //clearTimeout(this.loadObj);
   // this.$refs.AuditLogComponent
   this.$refs.auditLogComponent.loadInit();
  }, // mounted
unmounted() {
      clearTimeout(this.TimerObject);
    },
  watch: {
    selectedUsersId: function () {
      this.getFilterData();
    },
    selectedAppModelsId: function () {
      this.getFilterData();
    },
    filterDate: function () {
      this.getFilterData();
    },
  },
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.timeline {
  position: relative;
  padding: 20px 0 20px;
  list-style: none;
  max-width: 1600px;
  margin: 0 auto; }

  .timeline-margin {
    margin: 25px 0px 25px 50px !important }

.timeline:before {
  content: " ";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 3px;
  margin-left: -1.5px;
  background-color: #e9ecef; }

  .timeline-history:before {
    left: 1% !important;
   }

.timeline > li {
  position: relative;
  margin-bottom: 20px; }

  .timeline > .history-li {
    margin-bottom: 0px !important; }

.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table; }

.timeline > li:after {
  clear: both; }

.timeline > li:before,
.timeline > li:after {
  content: " ";
  display: table; }

.timeline > li:after {
  clear: both; }


  .timeline > li > .history-panel {
    left: 30px !important;
    top: 8px !important;
    width: 100% !important;
    padding: 10px !important;
    border: 0px !important;
    -webkit-box-shadow: 0 1px 6px rgb(0 0 0 / 0%) !important;
    box-shadow: 0 1px 6px rgb(0 0 0 / 0%) !important;
  }

.timeline > li > .timeline-panel {
  float: left;
  position: relative;
  width: 46%;
  padding: 20px;
  border: 1px solid #e9ecef;
  border-radius: 0.25rem;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05); }

.timeline > li > .timeline-panel:before {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 26px;
  right: -8px;
  border-top: 8px solid transparent;
  border-right: 0 solid #e9ecef;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #e9ecef; }

.timeline > li > .timeline-panel:after {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 27px;
  right: -7px;
  border-top: 7px solid transparent;
  border-right: 0 solid #fff;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #fff; }

.timeline > li > .timeline-badge {
  z-index: 10;
  position: absolute;
  top: 16px;
  left: 50%;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  border-radius: 50% 50% 50% 50%;
  text-align: center;
  font-size: 1.4em;
  line-height: 50px;
  color: #fff;
  overflow: hidden; }

  .timeline > li > .history-badge {
    top: 10px !important;
    left: 1.5% !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
  }

.timeline > li.timeline-inverted > .timeline-panel {
  float: right; }

.timeline > li.timeline-inverted > .timeline-panel:before {
  right: auto;
  left: -8px;
  border-right-width: 8px;
  border-left-width: 0; }

.timeline > li.timeline-inverted > .timeline-panel:after {
  right: auto;
  left: -7px;
  border-right-width: 7px;
  border-left-width: 0; }

.timeline-badge.primary {
  background-color: #fb9678; }

.timeline-badge.success {
  background-color: #00c292; }

.timeline-badge.warning {
  background-color: #fec107; }

.timeline-badge.danger {
  background-color: #e46a76; }

.timeline-badge.info {
  background-color: #03a9f3; }

.timeline-title {
  margin-top: 0;
  color: inherit;
  font-weight: 400; }

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0; }

.timeline-body > p + p {
  margin-top: 5px; }

/*******************
Horizontal Timeline page
******************/
.cd-horizontal-timeline .events a {
  padding-bottom: 6px;
  color: #fb9678; }

.cd-horizontal-timeline .filling-line,
.cd-horizontal-timeline .events a.selected::after {
  background: #fb9678; }

.cd-horizontal-timeline .events a.selected::after {
  border-color: #fb9678; }

.cd-horizontal-timeline .m-t-40 {
  margin-top: 40px !important; }
.text-payment{
  color: #38761d !important;
}
.text-communication{
  color:#e40ec0 !important;
}
</style>